module.exports = __webpack_public_path__ + "img/4.bd534c56.png";